module.exports = __webpack_public_path__ + "img/trc.b42ea5e4.png";